import React from "react";
import GLine from "../../assets/images/SGLine.png";
import YouTube from "../../assets/images/YouTube.jpeg";
import Event1 from "../../assets/images/Event1.png";
import Event2 from "../../assets/images/Event2.png";
import HLine from "../../assets/images/vBlueLine.png";
import { Fade } from "react-reveal";
const EventItem = ({ image, text, T, YTLink }) => (
  <div className="flex flex-col md:flex-row justify-center items-center mx-[2%] sm:mx-[5%] xl:mx-[7%] mt-8 space-y-5 md:space-y-1">
    <div
      className="shadow-2xl  max-w-[200px] min-h-[200px] min-w-[320px] sm:min-h-[250px] sm:min-w-[400px] md:min-h-[250px] md:min-w-[350px] lg:min-h-[300px] lg:min-w-[450px] xl:min-h-[350px] xl:min-w-[600px] 2xl:min-h-[400px] 2xl:min-w-[731px] z-30"
      style={{
        backgroundImage: `url(${image})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {T && (
        <div className="font-['FuturaExtraBold'] mt-24 ml-56 md:mt-28 md:ml-52 lg:mt-28 lg:ml-64 xl:mt-32 2xl:mt-44 xl:ml-96 text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-[white]">
          <p className="2xl:ml-24">STAY</p>
          <p className="2xl:ml-24">TUNED</p>
        </div>
      )}
    </div>
    <div className=" hidden md:block flex justify-center items-center mx-4">
      <Fade left>
        <img
          src={GLine}
          className="md:min-w-[40px] lg:min-w-[60px] xl:min-w-[80px] 2xl:min-w-[100px]"
          alt={""}
        />
      </Fade>
    </div>

    <div className="sm:hidden">
      <Fade top>
        <img
          src={HLine}
          alt={""}
          className="mt-1 md:mt-2 lg:mt-4 xl:mt-6 2xl:mt-10 h-[35px]"
        />
      </Fade>
    </div>
    <div className="flex flex-col justify-center items-center mx-12 sm:mx-24 md:mx-1 ">
      <p className="text-sm sm:text-md md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl px-1 xl:px-2 2xl:px-12 py-2">
        {text}
      </p>
      <button
        onClick={(e) => {
          e.preventDefault();
          window.open(YTLink);
        }}
        className="font-['FuturaExtraBold'] rounded-3xl shadow-2xl bg-[#008AC8] text-white px-3 lg:px-6 py-2 lg:py-3 xl:px-10 xl:py-6 text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-3xl self-end 2xl:mt-4 2xl:mx-8"
      >
        Link to Youtube
      </button>
    </div>
  </div>
);

const Events = () => {
  return (
    <div className="flex flex-col justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
      <p className="font-['FuturaExtraBold'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-[#00693A]">
        <Fade top>EVENTS</Fade>
      </p>
      <div className="md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24">
        <EventItem
          image={Event1}
          text={
            "Shedding light on social, judicial, financial, advocacy, secularist, environmental, & pollution management challenges, with experts from within and outside of Lebanon over a two-day event. Watch this series to know of the solutions the experts present and their advice for the Lebanese youth community."
          }
          T={false}
          YTLink="https://www.youtube.com/playlist?list=PLSzCqV-5Q1ive6Nn-QCSlokZr9zmtFlI0"
        />
        <EventItem
          image={Event2}
          text={
            "Activists from the international and the local community talk about their experience in different fields of activism. Watch this series to know how the international community deals with everyday challenges, and what the local community does to face challenges and advocate for action for a better, more inclusive Lebanon."
          }
          T={false}
          YTLink="https://www.youtube.com/playlist?list=PLSzCqV-5Q1it8LTytQsw3OYKB9UovOoi3"
        />
        <EventItem
          image={YouTube}
          text={
            "Want to stay in the loop? Subscribe to join the wave, and to know about our upcoming plans and events."
          }
          T={true}
          YTLink="https://youtube.com/channel/UC1CE-w_I09k7_1RnwsEjVgQ"
        />
      </div>
    </div>
  );
};

export default Events;
